module.exports = __webpack_public_path__ + "img/shutterstock_375299896.95314dc4.jpg";